import apiServiceReportFinance from '@api/apiServiceReportFinance';
import factory from '@helpers/storeFactories/factory';
import { mutationTypes } from '@helpers/storeFactories/helpers';
import storeConstants from '@/utils/constants/store';
import {
    normalizeItem,
    normalizeTotalsItem,
} from '@/data/response/normalizeReportFinanceCommissionDetails';

const STORE_NAME = 'hotelPriceRules';

const store = factory.createStore(
    STORE_NAME,
    {
        get: apiServiceReportFinance.commissionDetails.get,
    },
    {
        actions: {},
        actionsOptions: {
            get: {
                defaultOptions: {
                    refresh: false,
                    offset: 0,
                    limit: 99,
                },
                controlItems: storeConstants.ACTION_GET_CONTROL_ITEMS.ALL,
            },
        },
        normalizeItemFn: normalizeItem,
    },
    {
        mutations: {
            [mutationTypes.SET_TOTALS](state, totals) {
                state.totals = totals.map(normalizeTotalsItem);
            },
        },
    }
);

export default store;
